import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Page } from "../../../../helbest";
import Header from "../../Cart/Header/Header";
import { useAppointment } from "../useAppointment";
import { useTranslation } from "react-i18next";
import styles from "./AppointmentDetail.module.css";
import Loading from "../../../components/Loading/Loading";
import { dateFormatter } from "../../../../base/utils";
import HeaderBack from "../../../../helbest/HeaderBack/HeaderBack";

const AppointmentDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const { appointmentDetail } = useAppointment();

  useEffect(() => {
    appointmentDetail(id, setData, setLoading);
  }, []);

  return (
    <Page
      back={true}
      address="/appointment"
      footer={<></>}
      customHeader={<HeaderBack title={t("appointment.details.title")} />}
      headerFix
      logo
      showFooter={false}
    >
      {loading && (
        <div className={styles.Loading}>
          <Loading />
        </div>
      )}
      {data && !loading ? (
        <div className="mt-4">
          <div className={styles.DetailCardContainer}>
            <div
              className={`${styles.detailHeader} ${
                data.expired_at ? styles.expired : ""
              }`}
            >
              <span>{data.delivery_date?.replaceAll("-", "/")}</span>
              {data.expired_at ? (
                <span className={styles.expiredBadge}>
                  {t("common.expired")}
                </span>
              ) : null}
            </div>
            <div
              className={`${styles.box} ${
                i18n.dir() === "rtl" ? styles.rtl : ""
              }`}
            >
              <div>{t("service_details.product_name")}</div>
              <div>{data.product_name}</div>
              <div>{t("orderdetails.quantity")}</div>
              <div>{data.quantity}</div>

              <div>{t("common.id_number")}</div>
              <div>{data.id}</div>
              <div>{t("appointment.customer_name")}</div>
              <div>
                {data.fullname?.trim() || (
                  <>
                    <div className="px-1">_&#8197;_</div>
                  </>
                )}
              </div>
              <div>{t("appointment.customer_phone")}</div>
              <div>{data.mobile}</div>
              {data.expired_at ? (
                <>
                  <div>{t("orderdetails.expired_at")}</div>
                  <div>
                    {dateFormatter(data.expired_at, {
                      weekday: "short",
                      month: "short",
                      day: "numeric",
                    })}
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </Page>
  );
};

export default AppointmentDetail;
